var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaycash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5137 3.3481C10.5137 2.38802 11.6812 1.91485 12.3496 2.60404L18.5084 8.95449C18.914 9.37273 19.1409 9.93245 19.1409 10.5151V17.8657C19.1409 18.8257 17.9733 19.2989 17.3049 18.6097L11.1461 12.2593C10.7405 11.841 10.5137 11.2813 10.5137 10.6987V3.3481Z",
    fill: "#29133E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16797 3.13716C5.16797 2.17709 6.33554 1.70391 7.00394 2.39311L13.0718 8.64984C13.5357 9.12818 13.7952 9.76834 13.7952 10.4347V17.6547C13.7952 18.6148 12.6276 19.088 11.9592 18.3988L5.80042 12.0483C5.39481 11.6301 5.16797 11.0704 5.16797 10.4878V3.13716Z",
    fill: "#4C4CFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.3481C0 2.38802 1.16757 1.91485 1.83597 2.60404L7.99475 8.95449C8.40036 9.37273 8.62719 9.93245 8.62719 10.5151V17.8657C8.62719 18.8257 7.45962 19.2989 6.79123 18.6097L0.632446 12.2593C0.226837 11.841 0 11.2813 0 10.6987V3.3481Z",
    fill: "#130A81"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaycash);
export default __webpack_public_path__ + "static/media/paycash.f4daa62d.svg";
export { ForwardRef as ReactComponent };